/**
 * Canonical user-facing display names for Kinetik products. The "Kinetik"
 * prefix is intentional and required (SEO + legal); the bare name is too
 * generic to stand alone.
 *
 * Frozen so the canonical names cannot be mutated at runtime. This is the
 * single source of truth for product names in the UI.
 *
 * This app is Atlas, so only Trip Scheduler is defined here.
 */
export const PRODUCT_DISPLAY_NAMES = Object.freeze({
  TRIP_SCHEDULER: 'Kinetik Atlas',
});
